var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8762 14H12.1238C10.4014 14 9 15.4014 9 17.1238V33.4582C9 35.1806 10.4013 36.582 12.1238 36.582H37.8762C39.5986 36.582 41 35.1806 41 33.4582V17.1238C41 15.4014 39.5986 14 37.8762 14ZM35.9403 16.5686L25.0001 25.2564L14.0597 16.5686H35.9403ZM37.8762 34.0133H12.1238C11.8177 34.0133 11.5686 33.7643 11.5686 33.4581V17.8702L24.2013 27.902C24.4352 28.0877 24.7176 28.1806 24.9999 28.1806C25.2823 28.1806 25.5648 28.0878 25.7986 27.902L38.4314 17.8702V33.4581C38.4314 33.7643 38.1823 34.0133 37.8762 34.0133Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b79b522bdcbc3d03a004096a5e19b5bd.svg";
export { ForwardRef as ReactComponent };